<div class="labeled-radio-group">
  <div class="labeled-radio-group__label">{{ label() }}</div>
  <mat-radio-group
    [value]="value()"
    (change)="onChange($event.value)"
    class="labeled-radio-group__radio-group"
  >
    <mat-radio-button
      labelPosition="before"
      [value]="true"
      class="labeled-radio-group__radio-button"
    >
      <span class="labeled-radio-group__radio-label">
        {{ firstRadioLabel() }}
      </span>
    </mat-radio-button>

    <mat-radio-button
      labelPosition="before"
      [value]="false"
      class="labeled-radio-group__radio-button"
    >
      <span class="labeled-radio-group__radio-label">
        {{ secondRadioLabel() }}
      </span>
    </mat-radio-button>
  </mat-radio-group>
</div>
